<template>
  <el-dialog
    class="import-user-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="组织选择" prop="OrgId" >
        <el-select
          v-model="editForm.OrgId"
          placeholder="请选择"
          clearable
          class="auto-width"
          @change="handleSelect"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.OrgName"
            :value="item.OrgId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="用户名称" prop="UserName">
        <el-input v-model="editForm.UserName" placeholder="请输入"></el-input>
      </el-form-item> -->

      <el-form-item label="用户身份标识（公钥）" prop="UserName" >
        <template slot="label">
          <span
            >用户身份标识（公钥）
            <el-tooltip class="item" effect="dark" placement="right">
              <i class="el-icon-question common-icon" ></i>
              <div slot="content">
                <p>用于生成公钥的身份标识信息</p>
              </div>
            </el-tooltip>
          </span>
        </template>
        <el-input v-model="editForm.UserName"></el-input>
      </el-form-item>
      <el-form-item label="密码算法" prop="Algorithm" >
        <el-select v-model="editForm.Algorithm" placeholder="请选择" clearable class="auto-width">
          <el-option
            v-for="item in AlgoOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户签名证书" prop="SignCert" >
        <upload-files ref="signCert"></upload-files>
      </el-form-item>
      <el-form-item label="用户签名私钥" prop="SignKey" >
        <upload-files ref="signKey"></upload-files>
      </el-form-item>
      <el-form-item label="用户TLS证书" prop="TlsCert" >
        <upload-files ref="tlsCert"></upload-files>
      </el-form-item>
      <el-form-item label="用户TLS私钥" prop="TlsKey" >
        <upload-files ref="tlsKey"></upload-files>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'ImportUserCert',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 200
  },
  data() {
    return {
      title: '导入IBC用户证书',
      dialogVisible: false,
      disabled: false,
      editForm: {
        OrgId: '',
        OrgName: '',
        SignCert: 'file',
        SignKey: 'file',
        TlsCert: 'file',
        TlsKey: 'file',
        Algorithm: 2,
        Type: 2,
        UserName: ''
      },
      editRules: {
        OrgId: [{ required: true, message: '请选择组织', trigger: 'blur' }],
        UserName: [{ required: true, message: '请填写用户身份标识（公钥）', trigger: 'blur' }],
        Algorithm: [{ required: true, message: '请选择密码算法', trigger: 'blur' }],
        SignCert: [{ required: true, message: '请上传文件', trigger: 'blur' }],
        SignKey: [{ required: true, message: '请上传文件', trigger: 'blur' }],
        TlsCert: [{ required: true, message: '请上传文件', trigger: 'blur' }],
        TlsKey: [{ required: true, message: '请上传文件', trigger: 'blur' }]
      },
      options: [],
      AlgoOptions: [
        // { label: '国密', value: 0 },
        // { label: 'ECDSA', value: 1 },
        { label: 'IBC', value: 2 }
      ],
      adaptationVars: {
        formLabelWidth: 200
      }
    }
  },
  methods: {
    getOptions() {
      this.$apis.certificate.getOrgList({ limit: 50, offset: 0, certType: 0 }).then(res => {
        if (res.data && res.data.items) {
          this.options = res.data.items
        }
      })
    },
    handleCancel() {
      this.$refs.signCert.clear()
      this.$refs.tlsCert.clear()
      this.$refs.signKey.clear()
      this.$refs.tlsKey.clear()
      this.$refs.editForm.clearValidate()
      this.disabled = false
      this.editForm = {
        OrgId: '',
        OrgName: '',
        SignCert: 'file',
        SignKey: 'file',
        TlsCert: 'file',
        TlsKey: 'file',
        Algorithm: 2,
        Type: 2,
        UserName: ''
      }
      this.dialogVisible = false
    },
    handleOpen() {
      this.getOptions()
      this.dialogVisible = true
    },
    handleSelect(val) {
      let item = this.options.filter(ele => ele.OrgId === val)
      this.editForm.OrgName = item[0]['OrgName'] || ''
    },
    handleOk() {
      const testResult = this.$utils.checkCertificateName(this.editForm.UserName)
      if (testResult) {
        this.$message.error(testResult)
        return
      }
      this.disabled = true
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          let signCert = this.$refs.signCert.getFileRaw()
          let tlsCert = this.$refs.tlsCert.getFileRaw()
          let signKey = this.$refs.signKey.getFileRaw()
          let tlsKey = this.$refs.tlsKey.getFileRaw()
          if (!signCert || !signKey || !tlsCert || !tlsKey) {
            this.disabled = false
            return
          }
          await this.uploadFile(signCert, tlsCert, signKey, tlsKey)
          let submitCertFn = setInterval(() => {
            if (
              this.SignCert != 'file' &&
              this.SignKey != 'file' &&
              this.TlsCert != 'file' &&
              this.TlsKey != 'file'
            ) {
              this.$apis.certificate
                .importUserCert(this.editForm)
                .then(res => {
                  this.$message.success('用户证书导入成功!')
                  this.$emit('update:list')
                  this.handleCancel()
                })
                .catch(err => {
                  this.disabled = false
                })
              clearInterval(submitCertFn)
            }
          }, 500)
        } else {
          this.$message.warning('请填写内容')
          this.disabled = false
          return
        }
      })
    },
    uploadFile(signCert, tlsCert, signKey, tlsKey) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('name', signCert.name)
        formData.append('file', signCert.raw)
        let formData1 = new FormData()
        formData1.append('name', tlsCert.name)
        formData1.append('file', tlsCert.raw)
        let formData2 = new FormData()
        formData2.append('name', signKey.name)
        formData2.append('file', signKey.raw)
        let formData3 = new FormData()
        formData3.append('name', tlsKey.name)
        formData3.append('file', tlsKey.raw)
        let arr = [
          { name: 'SignCert', data: formData },
          { name: 'TlsCert', data: formData1 },
          { name: 'SignKey', data: formData2 },
          { name: 'TlsKey', data: formData3 }
        ]
        arr.map((ele, index) => {
          this.$apis.certificate
            .uploadCertificateFile(ele.data)
            .then(res => {
              if (res.data) {
                this.$set(this.editForm, ele.name, res.data)
                if (index === arr.length - 1) {
                  resolve(true)
                }
              }
            })
            .catch(err => {
              this.$message.error(`文件${ele.name}上传失败`)
              reject(false)
              return
            })
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.import-user-cert-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }

  .common-icon {
    vertical-align: middle;
    font-size: var(--base-font-size-common);
  }
}

</style>
